import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fbsWarehouseFallback: {
    id: 'UviorD',
    defaultMessage: 'FBS Warehouse',
    description: 'Fallback name for FBS warehouse when name is not found',
  },
  fbsWarehouseWest: {
    id: 'OOhsko',
    defaultMessage: 'FBS West',
    description: 'Name for the FBS West warehouse location',
  },
  fbsWarehouseSouthwest: {
    id: 'yZ5rtB',
    defaultMessage: 'FBS Southwest',
    description: 'Name for the FBS Southwest warehouse location',
  },
  fbsWarehouseMidwest: {
    id: 'FVVUqb',
    defaultMessage: 'FBS Midwest',
    description: 'Name for the FBS Midwest warehouse location',
  },
  fbsWarehouseSoutheast: {
    id: 'GkDocd',
    defaultMessage: 'FBS Southeast',
    description: 'Name for the FBS Southeast warehouse location',
  },
  fbsWarehouseNortheast: {
    id: 'GHutQo',
    defaultMessage: 'FBS Northeast',
    description: 'Name for the FBS Northeast warehouse location',
  },
});
